import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 快报详情
 */
import api from 'api/dayaoApi';
export default {
  name: 'page-report-detail',
  data: function data() {
    return {
      information: null,
      loading: false
    };
  },
  watch: {
    '$route.query': {
      handler: function handler(val) {
        if (val && val['reportId']) {
          this.selectBody(parseInt(val.reportId));
        }
      },
      immediate: true
    }
  },
  methods: {
    selectBody: function selectBody(id) {
      var vm = this;
      vm.loading = true;
      var params = {
        cid: 29,
        aid: id
      };
      api.get('/api/getKuaiBao.json', params).then(function (res) {
        vm.information = res.data;
        vm.loading = false;
      });
    },
    getTime: function getTime(time) {
      if (time) {
        return time.substring(time.indexOf(' '), -1);
      }

      return null;
    },
    manageContent: function manageContent(val) {
      return val.replace(/src=['"]([^'"]+)[^>]/g, function (match, acpture) {
        return 'src=\'http://old.dayaotex.com' + acpture + '\'';
      });
    }
  }
};